import get from 'lodash/get';
import { createSelector } from 'reselect';
import { reduxKey } from './constants';
import { denormalize } from '../normalizr';
export var getDataEntities = function (state) { return state[reduxKey]; };
export var getDataEntityById = function (state, entitySchema, id) {
    var entities = getAllDataEntitiesForSchema(state, entitySchema);
    if (entities) {
        return entities[id];
    }
};
export var getAllDataEntitiesForSchema = function (state, entitySchema) { return get(state, reduxKey + "." + entitySchema.key); };
export var getAllDataEntitiesForSchemaArray = function (state, entitySchema) {
    var entities = getAllDataEntitiesForSchema(state, entitySchema) || {};
    return Object.keys(entities).map(function (key) { return entities[key]; });
};
/**
 * Important! Do not use any Denormalized selectors for components
 * It will cause re-rendering, because will be not optimized for reselect
 */
export var getDenormalizedDataEntityById = function (state, entitySchema, id) { return denormalize(id, entitySchema, state[reduxKey]); };
export var getAllDenormalizedDataEntitiesForSchema = function (state, entitySchema /* should be schema.Entity, but even though schema.Entity has isAttribute, it is not a part of the interface. Sadface. */) {
    return denormalize(Object.keys(get(state, reduxKey + "." + entitySchema.key, {})), [entitySchema], get(state, reduxKey)).reduce(function (result, entity) {
        // key by idAttribute
        var idAttribute = typeof entitySchema.idAttribute === 'function'
            ? 'id'
            : entitySchema.idAttribute;
        result[entity[idAttribute]] = entity;
        return result;
    }, {});
};
export var getDenormalizedDataEntitiesByIds = createSelector([
    function (state, entitySchema, ids) {
        return getAllDenormalizedDataEntitiesForSchema(state, entitySchema);
    },
    function (state, entitySchema, ids) { return ids; },
], function (allDeviationsKeyedByIds, ids) {
    return ids.map(function (id) { return allDeviationsKeyedByIds[id]; }).filter(function (i) { return i !== undefined; });
});
//# sourceMappingURL=selectors.js.map